import { FeatureFeedback, Post, PostWrapper } from '@support/models/post.model';
import { PostSearchFilter, PostSearchResponse } from '@support/services/newsfeed.service';
import { addRefToFeatureFeedback, addRefToPost } from './newsfeed-utils';

export class NewsfeedGetPostAction {
  static readonly type = '[API Newsfeed] Get post';
  constructor(public slug: string) {}
}

export class NewsfeedGetPostSuccessAction {
  static readonly type = '[API Newsfeed] Get post success';
  constructor(public response: Post) {
    this.response = addRefToPost(this.response);
  }
}

export class NewsfeedGetPostErrorAction {
  static readonly type = '[API Newsfeed] Get post error';
  constructor(public error: string) {}
}

export class PostSearchAction {
  static readonly type = '[API Newsfeed] Post search';
  constructor(public searchRequest: PostSearchFilter) {}
}

export class PostSearchSuccessAction {
  static readonly type = '[API Newsfeed] Post search success';
  constructor(
    public searchResponse: PostSearchResponse,
    public searchRequest: PostSearchFilter
  ) {
    this.searchResponse.data = this.searchResponse.data.map(post => addRefToPost(post));
  }
}

export class PostSearchFailedAction {
  static readonly type = '[API Newsfeed] Post search failed';
  constructor(public error: string) {}
}

export class AppendNewPostsAction {
  static readonly type = '[API Newsfeed] Append new posts';
}

export class AppendNewPostsSuccessAction {
  static readonly type = '[API Newsfeed] Append new posts success';
  constructor(
    public searchResponse: PostSearchResponse,
    public searchRequest: PostSearchFilter
  ) {
    this.searchResponse.data = this.searchResponse.data.map(post => addRefToPost(post));
  }
}

export class AppendNewPostsFailedAction {
  static readonly type = '[API Newsfeed] Append new posts failed';
}

export class GetCombinedPostsAction {
  static readonly type = '[API Newsfeed]  Get combined posts';
}

export class GetCombinedPostsSuccessAction {
  static readonly type = '[API Newsfeed] Get combined posts success';
  constructor(public combinedPosts: PostWrapper[]) {
    this.combinedPosts = this.combinedPosts.map(postWrapper => {
      if (postWrapper.post) {
        return {
          ...postWrapper,
          post: addRefToPost(postWrapper.post),
        };
      } else {
        return {
          ...postWrapper,
          featureFeedback: addRefToFeatureFeedback(postWrapper.featureFeedback),
        };
      }
    });
  }
}

export class GetCombinedPostsFailedAction {
  static readonly type = '[API Newsfeed] Get combined posts failed';
}

export class GetFeatureFeedbacksAction {
  static readonly type = '[API Newsfeed] Get feature feedbacks';
}

export class GetFeatureFeedbacksSuccessAction {
  static readonly type = '[API Newsfeed] Get feature feedbacks success';
  constructor(public featureFeedbacks: FeatureFeedback[]) {
    this.featureFeedbacks = this.featureFeedbacks.map(featureFeedback => addRefToFeatureFeedback(featureFeedback));
  }
}

export class GetFeatureFeedbacksFailedAction {
  static readonly type = '[API Newsfeed] Get feature feedbacks failed';
}
